/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_Options_And_ToolsInputs */



/**
* | output |
* | --- |
* | "View options and tools" |
*
* @param {View_Options_And_ToolsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const view_options_and_tools = /** @type {((inputs?: View_Options_And_ToolsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_Options_And_ToolsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Options d'affichage et outils")
	if (locale === "de") return /** @type {LocalizedString} */ ("Optionen und Werkzeuge anzeigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visualizza opzioni e strumenti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Параметры просмотра и инструменты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ver opciones y herramientas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("查看选项和工具")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オプションとツールを表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विकल्प और उपकरण देखें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opções e ferramentas de visualização")
	return /** @type {LocalizedString} */ ("View options and tools")
});